import { PHOTO_CATEGORIES } from "./photo-categories";

/** Rotulos dos tipos de evidencia fotografica (cta.inspection_evidence.evidence_type). */
export const EVIDENCE_TYPE_LABELS: Record<string, string> = Object.fromEntries(
  PHOTO_CATEGORIES.map((c) => [c.code, c.label]),
);
